import React from 'react'

import { useGetProviderIconUrl } from './hooks/use-get-provider-icon-url'

interface TiveIconProps {
  size?: number
}

/**
 * The Tive icon component
 */
export const TiveIcon = ({ size = 6 }: TiveIconProps) => {
  // Convert size to pixels (assuming the original size 6 meant 24px)
  const sizeInPixels = size * 4
  const wrapperPaddingClass = size <= 4 ? 'p-0.5' : 'p-1'
  const iconUrl = useGetProviderIconUrl('api', 'icon')

  return (
    <div
      className={`flex items-center justify-center rounded-md border border-gray-200 ${wrapperPaddingClass} dark:border-gray-700`}
    >
      <img
        className={`h-${size} w-${size}`}
        style={{
          height: `${sizeInPixels}px`,
          width: `${sizeInPixels}px`
        }}
        src={iconUrl}
        aria-label="tive-icon"
        alt="Tive icon"
      />
    </div>
  )
}
